import { render, staticRenderFns } from "./Configuracion.vue?vue&type=template&id=ac208070&scoped=true"
import script from "./Configuracion.vue?vue&type=script&lang=ts"
export * from "./Configuracion.vue?vue&type=script&lang=ts"
import style0 from "./Configuracion.vue?vue&type=style&index=0&id=ac208070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac208070",
  null
  
)

export default component.exports